<template>
  <!-- <card :header-text="'Raw Data '+ company.companyname"> -->
  <div>
    <div class="row mb5 mt15">
      <div class="col-md-6">
        <div class="table-responsive app" v-dragscroll="true">
          <table class="table table-bordered fonts11 app-inner">
            <!-- <thead>
            <tr><th colspan="2">Last Year's Data</th></tr>
            </thead>-->
            <tbody>
              <tr>
                <th class="text-center">Sales (Year {{finYears[finYears.length-1]}})</th>
                <!-- <td>Sales Growth (Year {{finYears[finYears.length-1]}})</td> -->
              </tr>
              <tr>
                <td
                  class="text-center"
                >{{(compData && finYears.length>0)? getFixed(compData.years[finYears[finYears.length-1]]['sales']): '-'}}</td>
                <!-- <td>{{(compData && finYears.length>0)? getFixed(compData.years[finYears[finYears.length-1]]['sales_growth']): '-'}} </td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-md-6">
        <div class="table-responsive app" v-dragscroll="true">
          <table class="table table-bordered fonts11 app-inner">
            <!-- <thead>
            <tr><th colspan="2">Last Year's Data</th></tr>
            </thead>-->
            <tbody>
              <tr>
                <!-- <td>Sales (Year {{finYears[finYears.length-1]}})</td> -->
                <th class="text-center">Sales Growth (Year {{finYears[finYears.length-1]}})</th>
              </tr>
              <tr>
                <!-- <td>{{(compData && finYears.length>0)? getFixed(compData.years[finYears[finYears.length-1]]['sales']): '-'}}  </td> -->
                <td
                  class="text-center"
                >{{(compData && finYears.length>0)? getFixed(compData.years[finYears[finYears.length-1]]['sales_growth']): '-'}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="row mb5">
      <div class="col-md-8" :id="'sales'">
        <canvas :id="'sample'"></canvas>
      </div>
    </div>
    <div class="row mb5">
      <div class="col-md-6" :id="'sales-graph-content3'">
        <canvas :id="'salesdata3'"></canvas>
      </div>
      <div class="col-md-6" :id="'sales-graph-content13'">
        <canvas :id="'salesgrowthdata3'"></canvas>
      </div>
    </div>

    <div class="row mb5">
      <div class="col-md-6" :id="'sales-graph-content'">
        <canvas :id="'salesdata'"></canvas>
      </div>
      <div class="col-md-6" :id="'sales-graph-content-1'">
        <canvas :id="'salesgrowthdata'"></canvas>
      </div>
    </div>
    <div class="row mt15">
      <div class="col-md-4"></div>
      <div class="col-md-1"></div>
      <div class="col-md-1" v-if="company">
        <download :tableId="company.companyname+'-'+type" :fileName="company.companyname+'-'+type"></download>
      </div>
      <div class="table-responsive mt15" v-dragscroll="true" v-if="company">
        <table class="table fonts11 w50" :id="company.companyname+'-'+type">
          <thead>
            <tr>
              <th>Date</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(d, ind) in comPriceData" :key="'d'+ind">
              <td>{{compPriceLables[ind]}}</td>
              <td>{{d}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <!-- </card> -->
</template>
<script>
import { commonMixins } from "../../../assets/mixins/common.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
export default {
  props: ["graphData", "company", "type", "years", "finalData"],
  mixins: [commonMixins],
  created() {
    // this.getCompaniesList();
    console.log(ChartDataLabels);
    // ChartDataLabels.datalabels.align = 'top';
  },
  methods: {
    getDurationData(ind) {
      this.duration[this.selDur].active = 0;
      this.duration[ind].active = 1;
      this.selDur = ind;
      var durDate = new Date();
      var curDate = new Date();
      durDate = this.minusMonths(
        new Date(curDate.getFullYear(), curDate.getMonth(), "01"),
        this.duration[ind].duration
      );
      console.log("durDate", durDate, curDate);
      this.getDataForDuration(curDate, durDate);
    },
    getDataForDuration(curDate, durDate) {
      (this.comPriceData = []), (this.compPriceLables = []);
      this.companyPrices.forEach((val, key) => {
        var ddate = new Date(val.date);
        console.log(val, ddate, ddate > durDate, durDate);
        if (ddate > durDate) {
          this.compPriceLables.push(this.getDate(val.date));
          this.comPriceData.push(val.Close);
        }
      });
      console.log("this.comPriceData", this.compPriceLables.length);
      // this.comPriceData = this.getDataInRatio(this.comPriceData);
      console.log("this.comPriceData", this.comPriceData, this.compPriceLables);
      // this.plotGraph();
      this.configureChart();
    },
    plotGraph() {
      console.log("Plot Graph", this.compData, this.compData.co_code);
      if (this.compData.co_code != "") {
        setTimeout(() => {
          this.configureChart();
        });
      }
    },
    config10YearsSales() {
      var salesGraphContent = document.getElementById("sales-graph-content");
      salesGraphContent.innerHTML = "&nbsp;";
      $("#sales-graph-content").append('<canvas id="salesdata"><canvas>');
      var ctx = $("#salesdata")
        .get(0)
        .getContext("2d");
      var chart = new Chart(ctx, {
        // The type of chart we want to create
        type: "bar",
        // The data for our dataset
        data: {
          labels: this.compPriceLables,
          datasets: [
            {
              label: this.compData.companyname,
              backgroundColor: "rgba(255, 99, 132, 0.2)", //"rgba(54, 162, 235, 0.2)",
              borderColor: "rgb(255, 99, 132)", //"rgba(54, 162, 235, 1)",
              borderWidth: 1,
              data: this.salesData
            }
          ]
        },
        // Configuration options go here
        options: {
          maintainAspectRatio: true,
          legend: {
            display: false
          },
          title: { display: true, text: "Sales 10 Years" },
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true
                },
                barPercentage: 0.5,
                barThickness: 6,
                maxBarThickness: 8,
                minBarLength: 2
              }
            ]
          },
          plugins: {
            datalabels: {
              display: true,
              align: "top",
              anchor: "end"
            }
          }
        }
      });
      chart.update();
    },
    config3YearsSales() {
      this.graphOptions["title"] = { display: true, text: "Sales 3 Years" };
      var salesGraphContent3 = document.getElementById("sales-graph-content3");
      salesGraphContent3.innerHTML = "&nbsp;";
      $("#sales-graph-content3").append('<canvas id="salesdata3"><canvas>');
      var ctx = $("#salesdata3")
        .get(0)
        .getContext("2d");
      var chart2 = new Chart(ctx, {
        type: "bar",
        data: {
          labels: this.compPriceLables.slice(
            Math.max(this.compPriceLables.length - 3, 1)
          ),
          datasets: [
            {
              label: this.compData.companyname,
              data: this.salesData.slice(
                Math.max(this.salesData.length - 3, 1)
              ),
              backgroundColor: "rgba(255, 99, 132, 0.2)", //"rgba(54, 162, 235, 0.2)",
              borderColor: "rgb(255, 99, 132)", //"rgba(54, 162, 235, 1)",
              borderWidth: 1
            }
          ]
        },
        options: {
          title: { display: true, text: "Sales 3 Years" },
          maintainAspectRatio: true,
          legend: {
            display: false
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true
                },
                barPercentage: 0.1,
                category: 0.5
                // barThickness: 2,
                // maxBarThickness: 8,
                // minBarLength: 2,
              }
            ]
          },
          plugins: {
            datalabels: {
              display: true,
              align: "top",
              anchor: "end"
            }
          }
        }
      });
    },
    config10YearsSalesGrowth() {
      this.graphOptions["title"] = {
        display: true,
        text: "Sales Growth 10 Years"
      };
      this.graphOptions["plugins"] = {
        datalabels: {
          display: true,
          align: "top",
          anchor: "end"
        }
      };
      var salesGraphContent1 = document.getElementById("sales-graph-content-1");
      salesGraphContent1.innerHTML = "&nbsp;";
      $("#sales-graph-content-1").append(
        '<canvas id="salesgrowthdata"><canvas>'
      );
      var ctx = $("#salesgrowthdata")
        .get(0)
        .getContext("2d");
      var chart1 = new Chart(ctx, {
        // The type of chart we want to create
        type: "line",
        // The data for our dataset
        data: {
          labels: this.salesGrowthLabels,
          datasets: [
            {
              label: this.compData.companyname,
              backgroundColor: "transparent",
              borderColor: "rgb(54, 162, 235)", //"#ffc107",
              pointBackgroundColor: "#ffffff",
              data: this.salesGrowthData
            }
          ]
        },
        // Configuration options go here
        options: this.graphOptions
      });
      chart1.update();
    },
    config3YearsSalesGrowth() {
      this.graphOptions["title"] = {
        display: true,
        text: "Sales Growth 3 Years"
      };
      this.graphOptions["plugins"] = {
        datalabels: {
          display: true,
          align: "top",
          anchor: "end"
        }
      };
      var salesGraphContent13 = document.getElementById(
        "sales-graph-content13"
      );
      salesGraphContent13.innerHTML = "&nbsp;";
      $("#sales-graph-content13").append(
        '<canvas id="salesgrowthdata3"><canvas>'
      );
      var ctx = $("#salesgrowthdata3")
        .get(0)
        .getContext("2d");
      var chart3 = new Chart(ctx, {
        // The type of chart we want to create
        type: "bar",
        // The data for our dataset
        data: {
          labels: this.salesGrowthLabels.slice(
            Math.max(this.salesGrowthLabels.length - 3, 1)
          ),
          datasets: [
            {
              label: this.compData.companyname,
              backgroundColor: "transparent",
              borderColor: "rgb(54, 162, 235)", //"#ffc107",
              pointBackgroundColor: "#ffffff",
              data: this.salesGrowthData.slice(
                Math.max(this.salesGrowthData.length - 3, 1)
              ),
              type: "line"
            }
          ]
        },
        // Configuration options go here
        options: this.graphOptions
      });
      chart3.update();
    },
    configsample() {
      var sales = document.getElementById("sales");
      sales.innerHTML = "&nbsp;";
      $("#sales").append('<canvas id="sample"><canvas>');
      var ctx = $("#sample")
        .get(0)
        .getContext("2d");
      var chart4 = new Chart(ctx, {
        type:"bar",
        data:{
          labels: this.salesGrowthLabels,
          datasets:[{
            label: "Sales",
            data: this.salesData,
            borderColor: "rgb(255, 99, 132)",
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            yAxisID: "id1"
            },
            {
            label: "Sales Growth",
            data: this.salesGrowthData,
            type: "line",
            fill:false,
            borderColor: "rgb(54, 162, 235)",
            yAxisID: "id2"
            }]
            },
            options: 
            {
              scales: 
              {
                yAxes: [{
                display: true,
                position: 'left',
                type: "linear",
                scaleLabel: {
                    display: true,
                    labelString: 'Sales',
                    beginAtZero: true,
                },
                gridLines: {
                  display: false
                },
                //yAxisID: "id1"
                id: "id1" // incorrect property name.
              },
              {
                scaleLabel: {
                    display: true,
                    labelString: 'Sales Growth',
                    beginAtZero: true,
                },
                //display: false,
                display: true, // Hopefully don't have to explain this one.
                type: "linear",
                position:"right",
                gridLines: {
                    display: false
                },
                //yAxisID: "id2"
                id: "id2" // incorrect property name.
              }]
            },
            plugins: {
              datalabels: {
                display: false,
                align: "top",
                anchor: "end"
              }
            }
            }
          }
      );
      chart4.update();
    },
    configureChart() {
      console.log("Configure Graph");
      this.configsample();
      this.config10YearsSales();
      this.config3YearsSales();
      this.config10YearsSalesGrowth();
      this.config3YearsSalesGrowth();
    }
  },
  data() {
    return {
      graphOptions: {
        maintainAspectRatio: true,
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              display: true,
              gridLines: {
                display: false
              }
            }
          ],
          yAxes: [
            {
              // ticks: {
              //   beginAtZero: true
              // },
              display: true,
              gridLines: {
                zeroLineColor: "#e8e9ef",
                color: "#e8e9ef",
                drawBorder: true
              }
            }
          ]
        },
        elements: {
          line: {
            tension: 0.00001,
            borderWidth: 1
          },
          point: {
            radius: 1,
            hitRadius: 10,
            hoverRadius: 1,
            borderWidth: 2
          }
        }
      },
      companyPrices: [],
      comPriceData: [],
      compPriceLables: [],
      isChartdataLoading: 0,
      duration: [
        { id: "1m", name: "1M", active: 0, duration: 0 },
        { id: "3m", name: "3M", active: 0, duration: 3 },
        { id: "6m", name: "6M", active: 0, duration: 6 },
        { id: "1y", name: "1Y", active: 0, duration: 12 },
        { id: "3Y", name: "3Y", active: 0, duration: 36 },
        { id: "5Y", name: "5Y", active: 0, duration: 60 },
        { id: "10Y", name: "10Y", active: 1, duration: 120 }
      ],
      selDur: 6,
      compData: {},
      salesGrowthLabels: [],
      salesData: [],
      salesGrowthData: [],
      finYears:[]
    };
  },
  watch: {
    finalData: function(value) {
      console.log("Company Data", value);
      this.compData = value;
      this.finYears = Object.keys(this.compData.years);
      console.log(this.finYears);
      // this.finYears.reverse();
      this.finYears.forEach((val, key) => {
        // console.log(key, val);
        this.compPriceLables.push(val);
        this.salesData.push(this.compData.years[val].sales);
        this.salesGrowthLabels.push(val);
        if (this.compData.years[val].sales_growth !== "-") {
          this.salesGrowthData.push(
            this.getFixed(this.compData.years[val].sales_growth)
          );
        } else {
          this.salesGrowthData.push(0);
        }
      });
      console.log("this.salesGrowthData", this.salesGrowthData);
      this.plotGraph();
    }
      
    },
    years: function(value){
      
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/company/company-price-graph/salesGraph.vue